import { selectFilterId } from '../selectors';
import * as types from '../types';

function setDepartureTimingRange(range, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_setDepartureTimingRange(filterId, range));
    };
}

function _setDepartureTimingRange(filterId, range) {
    return {
        meta: filterId,
        payload: range,
        type: types.SET_DEPARTURE_TIMING_RANGE,
    };
}

function setArrivalTimingRange(range) {
    return (dispatch, getState) => {
        const filterId = selectFilterId(getState());
        return dispatch(_setArrivalTimingRange(filterId, range));
    };
}

function _setArrivalTimingRange(filterId, range) {
    return {
        meta: filterId,
        payload: range,
        type: types.SET_ARRIVAL_TIMING_RANGE,
    };
}

function resetDepartureTiming(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_resetDepartureTiming(filterId));
    };
}

function _resetDepartureTiming(filterId) {
    return {
        meta: filterId,
        type: types.RESET_DEPARTURE_TIMING,
    };
}

function resetArrivalTiming(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_resetArrivalTiming(filterId));
    };
}

function _resetArrivalTiming(filterId) {
    return {
        meta: filterId,
        type: types.RESET_ARRIVAL_TIMING,
    };
}

export {
    resetArrivalTiming,
    resetDepartureTiming,
    setArrivalTimingRange,
    setDepartureTimingRange,
};
